import React from "react";
import Typography from "@material-ui/core/Typography";

export default function Title(props) {
	return (
		<Typography style={{marginLeft: "8px"}} variant="h5" color="primary">
			{props.children}
		</Typography>
	);
}
